<div class="row" *ngIf="(customerCarrierExclusionMap | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Customer</label>
                        <customer-dropdown [parentForm]="formGroup" [ctrlName]="'customerCtrl'" [placeholder]="'Enter Code'"
                                           [lookupType]="'billto'" (customerSelected)="onCustomerChange($event, 'customerCtrl')"></customer-dropdown>
                    </div>
                </div>
                <div class="row" *ngIf="(customer | json) != '{}'">
                    <div class="col">
                        <a target="_blank" [routerLink]="['/customer-detail', customer.customerCode]" tabindex="-1">{{customer.customerName}}</a><br />
                        <a target="_blank" [routerLink]="['/customer-detail', customer.customerCode]" tabindex="-1">{{customer.customerCode}}</a><br />
                        {{customer.address1}}<br />
                        {{customer.cityStateZip}}<br />
                        <i class="fas fa-globe"></i> {{customer.timeZoneName}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Notes</label>
                <input type="text" class="form-control" [(ngModel)]="customerCarrierExclusionMap.notes" required />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
